/* Roam & Rufus: the harness pictures in "Choose your pack" follow the harness colour that is selected.
   The two-pack shows dog 1's colour first and dog 2's colour beside it. */
(function(){
'use strict';
const BASE='https://cdn.shopify.com/s/files/1/0809/5144/3567/files/harness-';
const slug=s=>String(s).toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
function photo(sw){
  const bg=getComputedStyle(sw).backgroundImage||'';
  const m=bg.match(/url\(["']?([^"')]*harness-[^"')]*)["']?\)/);
  if(m)return m[1];
  const name=slug(sw.dataset.value||'');
  return name?BASE+name+'.webp?width=160':'';
}
function liven(){
  const picked=[...document.querySelectorAll('.color-swatch.selected[data-field="color"]')].map(photo).filter(Boolean);
  if(!picked.length)return;
  document.querySelectorAll('.offers .offer').forEach(card=>{
    const list=card.dataset.bundle==='true'?[picked[0],picked[1]||picked[0]]:[picked[0]];
    const sig=list.join('|');
    let box=card.querySelector('.rr-pack-pics');
    if(box&&box.dataset.sig===sig)return;
    if(!box){box=document.createElement('span');box.className='rr-pack-pics';box.setAttribute('aria-hidden','true');card.prepend(box);}
    box.dataset.sig=sig;
    box.textContent='';
    list.forEach(u=>{const i=document.createElement('i');i.style.backgroundImage='url("'+u+'")';box.appendChild(i);});
    card.classList.add('rr-haspics');
  });
}
function boot(){
  const store=document.getElementById('store');
  if(!store)return;
  liven();
  new MutationObserver(liven).observe(store,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
